export function capitalize (value) {
	const match = value.match(/[a-zA-Z]/);

	if (!match) {
		return value;
	}

	const { index } = match;
	return index >= 0 ? value.slice(0, index) + value[index].toUpperCase() + value.slice(index + 1) : '';
}

export function normalize (string) {
	return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function initials (value, maxlength) {
	return value.split(' ').slice(0, maxlength).map((word) => word[0]).join('');
}
